import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import CommonSelect from "../../core/common/commonSelect";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../core/data/redux/store";
import { Drawer, message } from "antd";
import View from "./action/view";
import Feedback from "./action/feedback";
import {
  getEmployees,
  getEmployeeBySupervisorId,
  getEmployeeByUserId,
  getEmployeeById,
} from "../../core/data/redux/employee/employeeAction";
import {
  updateappliedappraisal,
  fetchAllappliedappraisal,
} from "../../core/data/redux/performance/appraisal/appraisalAction";
import { fetchAllRoleindicator } from "../../core/data/redux/performance/roleindicator/roleindicatorAction";
import { fetchAllKRA } from "../../core/data/redux/performance/KRA/kraAction";
import { fetchalldetailsById } from "../../core/data/redux/performance/fullapraisaldetails/fullapraisaldetailsAction";
import { Modal } from "antd";
import {
  fetchachievemnetById,
  updateachievemnet,
} from "../../core/data/redux/performance/achievement/achievementAction";
import { fetchcommentById } from "../../core/data/redux/performance/comment/commentAction";
import { fetchpersonalgoalById } from "../../core/data/redux/performance/personalgoal/personalgoalAction";
import {
  fetchProfessionalGoalCurrentById,
  fetchProfessionalGoalLastById,
} from "../../core/data/redux/performance/goal/goalAction";
import { fetchappliedappraisalById, updateappliedappraisalrating } from "../../core/data/redux/performance/appliedappraisal/appliedappraisalAction";
import { filterByStatus } from "../../core/utils/filterActiveData";

const StarRating = ({
  rating,
  onRate,
}: {
  rating: any;
  onRate: (rating: any) => void;
}) => {
  const handleClick = (star: number, isHalf: boolean) => {
    const newRating = isHalf ? star - 0.5 : star;
    onRate(newRating);
  };

  return (
    <div style={{ display: "flex", gap: "4px" }}>
      {[1, 2, 3, 4, 5].map((star) => (
        <div
          key={star}
          style={{ position: "relative", fontSize: "24px", cursor: "pointer" }}
        >
          <span
            style={{
              position: "absolute",
              width: "50%",
              overflow: "hidden",
              color: rating >= star - 0.5 ? "gold" : "gray",
            }}
            onClick={() => handleClick(star, true)}
          >
            ★
          </span>

          <span
            style={{
              color: rating >= star ? "gold" : "gray",
            }}
            onClick={() => handleClick(star, false)}
          >
            ★
          </span>
        </div>
      ))}
    </div>
  );
};
const StarRating2 = ({
  rating,
  onRate,
}: {
  rating: any;
  onRate?: (rating: any) => void;
}) => {
  const handleClick = (star: number, isHalf: boolean) => {
    const newRating = isHalf ? star - 0.5 : star;
  };

  return (
    <div style={{ display: "flex", gap: "4px" }}>
      {[1, 2, 3, 4, 5].map((star) => (
        <div
          key={star}
          style={{ position: "relative", fontSize: "24px", cursor: "pointer" }}
        >
          <span
            style={{
              position: "absolute",
              width: "50%",
              overflow: "hidden",
              color: rating >= star - 0.5 ? "gold" : "gray",
            }}
            onClick={() => handleClick(star, true)}
          >
            ★
          </span>

          <span
            style={{
              color: rating >= star ? "gold" : "gray",
            }}
            onClick={() => handleClick(star, false)}
          >
            ★
          </span>
        </div>
      ))}
    </div>
  );
};

const PerformanceReview = () => {
  const { user } = useSelector((state: any) => state.auth);
  const dispatch = useDispatch<AppDispatch>();
  useEffect(() => {
    dispatch(getEmployees()).then((res: any) => {

    });
  }, []);

  const { roleindicator } = useSelector(
    (state: any) => state.performance.roleindicator
  );

  const [modalVisible, setModalVisible] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState<any>(null);
  const [feedbackModalVisible, setFeedbackModalVisible] = useState(false);
  const [feedbackEmployee, setFeedbackEmployee] = useState<any>(null);
  const [appliedappraisal, setappliedappraisal] = useState<any>(null);
  const [employeedata, setEmployeedata] = useState<any>([]);
  const [appliedappraisaldetails, setappliedappraisaldetails] = useState<any>(
    []
  );
  console.log(appliedappraisaldetails, 'app')
  const [achievement, setachievement] = useState<any>(null);
  const [comments, setcomments] = useState<any>(null);
  const [personalgoal, setpersonalgoal] = useState<any>(null);
  const [employees, setEmployees] = useState<any[]>([]);
  const activeEmployees = filterByStatus(employees, "active", "employee_status");
  const [statusMap, setStatusMap] = useState<{ [key: number]: string }>({});
  const [professionalgoallastyear, setprofessionalgoallastyear] =
    useState<any>(null);
  const [professionalgoalcurrentyear, setprofessionalgoalcurrentyear] =
    useState<any>(null);
  const handleView = (emp: any) => {
    setSelectedEmployee(emp);
    setViewModalOpen(true);

  };

  const handleFeedback = (emp: any) => {
    setSelectedEmployee(emp);
    setFeedbackModalOpen(true);

  };

  const closeModal = () => {
    setModalVisible(false);
    setSelectedEmployee(null);
  };

  const handleActionClick = (status: string, emp: any) => {
    dispatch(
      updateappliedappraisal({ id: emp.EmployeeID, data: { status } })
    ).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        message.success(res.payload.message);
        setFeedbackModalOpen(false)
      } else {
        message.warning("Not yet Applied");
        setFeedbackModalOpen(false)
      }
    });
  };

  useEffect(() => {
    dispatch(getEmployeeByUserId({ userId: user.UserId })).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        dispatch(
          getEmployeeById({ employeeId: res.payload.data.employeeId })
        ).then((res) => {
          dispatch(
            getEmployeeBySupervisorId({
              userId: res.payload.data.employee[0].SupervisorId,
            })
          ).then((res: any) => {
            setEmployees(res.payload.data || []);
          });
        });
      }
    });
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchAllappliedappraisal()).then((res) => {
      setappliedappraisal(res.payload.data);
    });
  }, []);

  useEffect(() => {
    let employeeId = selectedEmployee?.EmployeeID;
    dispatch(
      getEmployeeById({ employeeId: selectedEmployee?.EmployeeID })
    ).then((res) => {
      setEmployeedata(res.payload.data.employee);
      setemployeeExprience(res.payload.data.experience);
    });
    dispatch(fetchachievemnetById({ Id: selectedEmployee?.EmployeeID })).then(
      (res) => {
        setachievement(res?.payload.data);
      }
    );

    dispatch(fetchcommentById({ Id: selectedEmployee?.EmployeeID })).then(
      (res) => {
        setcomments(res?.payload.data);
      }
    );
    dispatch(fetchpersonalgoalById({ Id: selectedEmployee?.EmployeeID })).then(
      (res) => {
        setpersonalgoal(res.payload.data);
      }
    );
    dispatch(
      fetchProfessionalGoalLastById({ Id: selectedEmployee?.EmployeeID })
    ).then((res) => {
      setprofessionalgoallastyear(res?.payload.data);
    });
    dispatch(
      fetchProfessionalGoalCurrentById({ Id: selectedEmployee?.EmployeeID })
    ).then((res) => {
      setprofessionalgoalcurrentyear(res?.payload.data);
    });
    dispatch(fetchalldetailsById(selectedEmployee?.EmployeeID)).then((res) => {
      setrenderdata(res.payload.data);
    });
    dispatch(fetchappliedappraisalById(selectedEmployee?.EmployeeID)).then(
      (res) => {
        setappliedappraisaldetails(res.payload.data);
      }
    );
  }, [selectedEmployee]);

  useEffect(() => {
    if (employeedata.length > 0 && roleindicator.length > 0) {
      const uniqueDesignationIds = Array.from(
        new Set(employeedata.map((emp: any) => emp.DesignationId))
      );
      const matchedRoleIndicators = roleindicator.filter((role: any) =>
        uniqueDesignationIds.includes(role.DesignationId)
      );

      setFilteredRoleIndicators(matchedRoleIndicators);
    }
  }, [employeedata, roleindicator, selectedEmployee]);



  const [formData, setFormData] = useState<any>({});
  const [employeeExprience, setemployeeExprience] = useState<any>([]);
  const { kra } = useSelector((state: any) => state.performance.kra);
  const [data, setdata] = useState<any[]>([]);
  const [filteredRoleIndicators, setFilteredRoleIndicators] = useState<any[]>(
    []
  );
  const { employeesbyUser } = useSelector((state: any) => state.employee);
  const { employee } = useSelector((state: any) => state.employee);
  const [rows, setRows] = useState([{ id: 1, value: "" }]);
  const [comment, setComment] = useState("");
  const [renderdata, setrenderdata] = useState<any>(null);
  const [ratings, setRatings] = useState({
    hrRating: 0,
    hodRating: 0,
  });

  useEffect(() => {
    if (appliedappraisaldetails?.[0]) {
      setRatings({
        hrRating: parseFloat(appliedappraisaldetails?.[0]?.HrRating) || 0,
        hodRating: parseFloat(appliedappraisaldetails?.[0]?.HoDRating) || 0,
      });
    }
  }, [appliedappraisaldetails]);

  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);

  const handleemployeeRatingChange = (newRating: number) => {
    setFormData((prev: any) => ({ ...prev, rating: newRating }));
  };

  const handleemployeeSubmit = (e: any) => {
    e.preventDefault();

    const payload = {
      Id: appliedappraisaldetails?.[0]?.Id,
      employeeId: appliedappraisaldetails?.[0]?.employeeId,
      hrRating: ratings.hrRating,
      hodRating: ratings.hodRating,
      date: new Date().toISOString(),
    };

    dispatch(updateappliedappraisalrating(payload))
      .then((res) => {
        if (res.meta.requestStatus === "fulfilled") {
          message.success(res.payload.message)
        } else {
          message.warning(res.payload.message)
        }
      })
  };

  const handleInputChangeComment = (id: number, value: string) => {
    setRows((prevRows) =>
      prevRows.map((row) => (row.id === id ? { ...row, value } : row))
    );
  };

  const handleAddRow = () => {
    setRows([...rows, { id: rows.length + 1, value: "" }]);
  };

  const handleSubmitachivement = () => {
    const payload = {
      achievements: rows.map((row) => row.value),
      createdBy: user.UserId,
      employeeId: employeedata[0]?.EmployeeID || null,
    };
  };

  const handleSaveComment = () => {
    console.log({
      self_comment: comment,
      createdBy: user.UserId,
      employeeId: employeedata[0]?.EmployeeID || null,
    });
  };

  useEffect(() => {
    dispatch(
      getEmployeeById({ employeeId: feedbackEmployee?.EmployeeID })
    ).then((res) => {
      setEmployeedata(res.payload.data.employee);
      setemployeeExprience(res.payload.data.experience);
    });
    setSelectedEmployee(feedbackEmployee);
  }, [dispatch]);

  const routes = all_routes;

  useEffect(() => {
    dispatch(fetchAllRoleindicator());
    dispatch(fetchAllKRA());
  }, [dispatch]);

  const handleInputChange = (
    roleId: number,
    groupSerialNo: number,
    value: string,
    weightage: number
  ) => {
    const numericValue = parseInt(value, 10);

    if (numericValue > weightage) {
      return;
    }

    setFormData((prevData: any) => ({
      ...prevData,
      [`${roleId}_${groupSerialNo}`]: numericValue,
    }));
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();

    const structuredData = filteredRoleIndicators.map((role) => ({
      roleId: role.Id,
      roleName: role.Name,
      roleGroups: role.role_groups.map((group: any) => {
        const kraName =
          group.indicators.length > 0
            ? group.indicators[0]?.kra.name
            : "No KRA";

        const matchedKRA = kra.find((item: any) => item.kra_name === kraName);
        const kraId = matchedKRA ? matchedKRA.id : null;

        return {
          serialNo: group.serial_no,
          keyResultArea: kraId,
          keyPerformanceIndicators:
            group.indicators.length > 0
              ? group.indicators.map(
                (indicator: any) => indicator.indicator.name
              )
              : ["No Indicators"],
          weightage: group.weightage,
          pointsScored:
            formData[`${role.Id}_${group.serial_no}`] || "Not Entered",
        };
      }),
      createdBy: user.UserId,
      employeeId: employeedata[0].EmployeeID,
    }));
  };

  return (
    <>
      <div className="content">
        {/* Breadcrumb */}
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Performance Review</h2>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={routes.adminDashboard}>
                    <i className="ti ti-smart-home" />
                  </Link>
                </li>
                <li className="breadcrumb-item">Performance</li>
                <li className="breadcrumb-item active" aria-current="page">
                  Performance Review
                </li>
              </ol>
            </nav>
          </div>
          <div className="head-icons ms-2">
            <CollapseHeader />
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead className="thead-dark">
                  <tr>
                    <th
                      scope="col"
                      style={{
                        backgroundColor: "#582EB7",
                        color: "white",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      S.No
                    </th>
                    <th
                      scope="col"
                      style={{
                        backgroundColor: "#582EB7",
                        color: "white",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      Name
                    </th>
                    <th
                      scope="col"
                      style={{
                        backgroundColor: "#582EB7",
                        color: "white",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      Self Rating
                    </th>
                    <th
                      scope="col"
                      style={{
                        backgroundColor: "#582EB7",
                        color: "white",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      RO Rating
                    </th>
                    <th
                      scope="col"
                      style={{
                        backgroundColor: "#582EB7",
                        color: "white",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      HOD Rating
                    </th>
                    <th
                      scope="col"
                      style={{
                        backgroundColor: "#582EB7",
                        color: "white",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      Status
                    </th>
                    <th
                      scope="col"
                      style={{
                        backgroundColor: "#582EB7",
                        color: "white",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      Date
                    </th>
                    <th
                      scope="col"
                      style={{
                        backgroundColor: "#582EB7",
                        color: "white",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {activeEmployees?.length > 0 ? (
                    activeEmployees
                    ?.sort((a: any, b: any) =>`${a.FirstName} ${a.LastName}`.localeCompare(`${b.FirstName} ${b.LastName}`))
                    ?.map((emp, index) => {
                      const lastMatchedAppraisal = appliedappraisal
                        ?.slice()
                        .reverse()
                        .find((app: any) => app.employeeId === emp.EmployeeID);

                      return (
                        <tr key={emp.EmployeeID}>
                          <td>{index + 1}</td>
                          <td>{`${emp.FirstName} ${emp.LastName}`}</td>

                          <td>
                            {<StarRating2 rating={lastMatchedAppraisal?.selfRating}/>}
                          </td>
                          <td>
                            {<StarRating2 rating={lastMatchedAppraisal?.HrRating}/>}
                          </td>
                          <td>
                            {<StarRating2 rating={lastMatchedAppraisal?.HoDRating}/>}
                          </td>
                          <td>{lastMatchedAppraisal?.status || "N/A"}</td>
                          <td>
                            {lastMatchedAppraisal?.date
                              ? new Date(lastMatchedAppraisal.date)
                                .toISOString().split("T")[0]
                              : new Date(emp.CreatedAt).toISOString()
                                .split("T")[0]}
                          </td>

                          <td>
                            <button
                              className="btn btn-primary btn-sm me-2"
                              title="View"
                              //  onClick={() => setViewModalOpen(true)}
                              onClick={() => handleView(emp)}
                            >
                              <i className="fas fa-eye" />
                            </button>
                            <button
                              className="btn btn-success btn-sm me-2"
                              title="Approved"
                              onClick={() => handleActionClick("Approved", emp)}
                            >
                              <i className="fas fa-check" />
                            </button>
                            <button
                              className="btn btn-warning btn-sm me-2"
                              title="Hold"
                              onClick={() => handleActionClick("Hold", emp)}
                            >
                              <i className="fas fa-pause-circle" />
                            </button>
                            <button
                              className="btn btn-danger btn-sm me-2"
                              title="Reject"
                              onClick={() => handleActionClick("Rejected", emp)}
                            >
                              <i className="fas fa-times" />
                            </button>
                            <button
                              className="btn btn-info btn-sm"
                              title="Feedback"
                              onClick={() => handleFeedback(emp)}
                            >
                              <i className="fas fa-comment" />
                            </button>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={9} className="text-center">
                        No employees found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
        <p className="mb-0">2024 - 2025© hrmtree.</p>
        <p>
          Developed By{" "}
          <Link to="#" className="text-primary">
            Leadchain Systems
          </Link>
        </p>
      </div>

      {/* {modalVisible && (
        <View
          modalVisible={modalVisible}
          closeModal={closeModal}
          getemployee={selectedEmployee}
        />
      )} */}

      {/* {feedbackEmployee && feedbackModalVisible && (
        <Feedback empdata={feedbackEmployee} onClose={closeFeedbackModal} />
      )} */}

      {/* View Modal */}
      <Drawer
        title="View Details"
        open={viewModalOpen}
        onClose={() => setViewModalOpen(false)}
        placement="right"
        width="75%"
        bodyStyle={{ padding: 0, height: "100%", overflowY: "auto" }}
      >
        <div className="content container-fluid">
          <section className="card border-0">
            <div className="card-header border border-bottom-0 d-flex justify-content-between align-items-center">
              <h3 className="mb-2">Employee Information</h3>
            </div>
            <div className="row">
              <div className="col-md-12 col-sm-12">
                <div className="table-responsive">
                  <form>
                    <table
                      className="table table-bordered mb-0"
                      style={{ minWidth: "1000px" }}
                    >
                      <tbody>
                        <tr>
                          <td>
                            <div className="mb-3">
                              <label className="form-label" htmlFor="name">
                                Name
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="name"
                                value={employeedata?.[0]?.Name}
                                disabled
                              />
                            </div>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="department"
                              >
                                Department
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="department"
                                value={employeedata?.[0]?.department_name}
                                disabled
                              />
                            </div>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="designation"
                              >
                                Designation
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="designation"
                                value={employeedata?.[0]?.designation_name}
                                disabled
                              />
                            </div>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="qualification"
                              >
                                Qualification
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="qualification"
                                value={employeedata?.[0]?.HighestEducation}
                                disabled
                              />
                            </div>
                          </td>

                          <td>
                            <div className="mb-3">
                              <label className="form-label" htmlFor="empID">
                                Emp ID
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="empID"
                                value={employeedata?.[0]?.EmployeeNumber}
                                disabled
                              />
                            </div>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="dateOfJoin"
                              >
                                Date of Join
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="dateOfJoin"
                                value={
                                  employeedata?.[0]?.DateOfJoining?.split(
                                    "T"
                                  )[0]
                                }
                                disabled
                              />
                            </div>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="previousExperience"
                              >
                                Previous years of Exp
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="previousExperience"
                                value={employeedata?.[0]?.total_experience}
                                disabled
                              />
                            </div>
                          </td>

                          <td>
                            <div className="mb-3">
                              <label className="form-label" htmlFor="roName">
                                RO's Name
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="roName"
                                value={
                                  employeedata?.[0]?.supervisor_name || "Ram"
                                }
                                disabled
                              />
                            </div>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="roDesignation"
                              >
                                RO Designation
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="roDesignation"
                                value={employeedata?.[0]?.RODesignation || "IT"}
                                disabled
                              />
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </form>
                </div>
              </div>
            </div>
            <form onSubmit={handleSubmit}>
              <div>
                {filteredRoleIndicators?.length > 0 ? (
                  filteredRoleIndicators.map((role) => (
                    <section className="card border-0 mb-4" key={role.Id}>
                      <div className="card-header border border-bottom-0 text-center">
                        <h3 className="mb-2">
                          {role.Name} - Professional Excellence
                        </h3>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="table-responsive">
                            <table className="table table-bordered mb-0">
                              <thead>
                                <tr>
                                  <th className="width-pixel">#</th>
                                  <th>Key Result Area</th>
                                  <th>Key Performance Indicators</th>
                                  <th>Weightage</th>
                                  <th>Points Scored ( self )</th>
                                  <th>Points Scored (HR)</th>
                                  <th>Points Scored (HOD)</th>
                                </tr>
                              </thead>
                              <tbody>
                                {role.role_groups?.length > 0 ? (
                                  role.role_groups.map((group: any) => (
                                    <tr key={`${role.Id}-${group.serial_no}`}>
                                      <td>{group.serial_no}</td>
                                      <td>
                                        {group?.indicators?.length > 0
                                          ? group.indicators[0]?.kra.name
                                          : "No KRA"}
                                      </td>
                                      <td>
                                        {group?.indicators?.length > 0
                                          ? group.indicators[0]?.indicator.name
                                          : "No Indicator"}
                                      </td>
                                      <td>{group?.weightage}</td>
                                      <td>
                                        <input
                                          type="number"
                                          className="form-control"
                                          placeholder="Enter value"
                                          value={
                                            formData[
                                            `${role.Id}_${group.serial_no}`
                                            ] || 0
                                          }
                                          min="0"
                                          max={group.weightage}
                                          onChange={(e) =>
                                            handleInputChange(
                                              role.Id,
                                              group.serial_no,
                                              e.target.value,
                                              group.weightage
                                            )
                                          }
                                          onInput={(e: any) => {
                                            if (
                                              parseInt(e.target.value, 10) >
                                              group.weightage
                                            ) {
                                              e.target.value = group.weightage;
                                            }
                                          }}
                                        />
                                      </td>
                                      <td>{0}</td>
                                      <td>{0}</td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan={7} className="text-center">
                                      .....No Data Available
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div className="d-flex justify-content-end mt-3">
                          {/* <button
                            type="submit"
                            className="btn btn-primary me-3"
                          >
                            Save
                          </button> */}
                        </div>
                      </div>
                    </section>
                  ))
                ) : (
                  <div className="text-center">No Data Available</div>
                )}

                <div className="card-header border border-bottom-0 text-center">
                  <h3 className="mb-2">Achievements (if any)</h3>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="table-responsive">
                      <table className="table table-bordered table-review mb-0">
                        <thead>
                          <tr>
                            <th className="width-pixel">#</th>
                            <th>By Self</th>
                            <th>By HR</th>
                            <th>By HOD</th>
                          </tr>
                        </thead>
                        <tbody>
                          {achievement && achievement?.length > 0 ? (
                            achievement.map((ach: any, index: number) => (
                              <tr key={ach.id}>
                                <td>{index + 1}</td>
                                <td>{ach.achievement}</td>
                                <td>{ach.hr_achievement}</td>
                                <td>{ach.hod_achievement}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={4} className="text-center">
                                No achievements recorded.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div className="d-flex justify-content-end mt-3"></div>
                  </div>
                </div>
              </div>
            </form>
            <div className="card-header border border-bottom-0 text-center">
              <h3 className="mb-2">Comments on the Role</h3>
              <p className="text-muted">
                Alterations if any required like Addition/Deletion of
                Responsibilities
              </p>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="table-responsive">
                  <table
                    className="table table-bordered mb-0"
                    id="table_alterations"
                  >
                    <thead>
                      <tr>
                        <th className="width-pixel">#</th>
                        <th>By Self</th>
                        <th>By HR</th>
                        <th>By HOD</th>
                      </tr>
                    </thead>
                    <tbody id="table_alterations_tbody">
                      {comments && comments?.length > 0 ? (
                        comments.map((com: any, index: any) => (
                          <tr key={com.id}>
                            <td>{index + 1}</td>
                            <td>{com.self_comment}</td>
                            <td>{com.ro_comment}</td>
                            <td>{com.hod_comment}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={4} className="text-center">
                            No comments available.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="d-flex justify-content-end mt-3">
                  {/* <button type="submit" className="btn btn-primary me-3">
                   
                  </button> */}
                </div>
              </div>
            </div>
            <div className="card-header border border-bottom-0 text-center">
              <h3 className="mb-2">Personal Goals</h3>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="table-responsive">
                  <table className="table table-bordered mb-0">
                    <thead>
                      <tr>
                        <th className="width-pixel">#</th>
                        <th>Goal Achieved during last year</th>
                        <th>Goal set for current year</th>
                      </tr>
                    </thead>
                    <tbody>
                      {personalgoal && personalgoal.length > 0 ? (
                        personalgoal.map((goal: any, index: number) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{goal.personalgoallast?.join(", ") || ""}</td>
                            <td>
                              {goal.personalgoalcurrent?.join(", ") || ""}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={3} className="text-center">
                            No personal goals available.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="card-header border border-bottom-0 text-center">
              <h3 className="mb-2">
                Professional Goals Achieved for last year
              </h3>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="table-responsive">
                  <table className="table table-bordered mb-0" id="table_goals">
                    <thead>
                      <tr>
                        <th className="width-pixel">#</th>
                        <th>By Self</th>
                      </tr>
                    </thead>
                    <tbody id="table_goals_tbody">
                      {professionalgoallastyear &&
                        professionalgoallastyear.length > 0 ? (
                        professionalgoallastyear.map(
                          (goal: any, index: number) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={goal.goalName}
                                  disabled
                                />
                              </td>
                            </tr>
                          )
                        )
                      ) : (
                        <tr>
                          <td colSpan={2} className="text-center">
                            No professional goals from last year.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="card-header border border-bottom-0 text-center">
              <h3 className="mb-2">
                Professional Goals for the forthcoming year
              </h3>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="table-responsive">
                  <table
                    className="table table-bordered mb-0"
                    id="table_forthcoming"
                  >
                    <thead>
                      <tr>
                        <th className="width-pixel">#</th>
                        <th>By Self</th>
                      </tr>
                    </thead>
                    <tbody id="table_forthcoming_tbody">
                      {professionalgoalcurrentyear &&
                        professionalgoalcurrentyear.length > 0 ? (
                        professionalgoalcurrentyear.map(
                          (goal: any, index: number) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={goal.goalName}
                                  disabled
                                />
                              </td>
                            </tr>
                          )
                        )
                      ) : (
                        <tr>
                          <td colSpan={2} className="text-center">
                            No professional goals set for current year.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="row mb-4">
              <div className="col-md-12">
                <div className="table-responsive">
                  <table className="table table-bordered mb-0">
                    <thead>
                      <tr>
                        <th>Role</th>
                        <th>Frequency</th>
                        <th>HR-Rating</th>
                        <th>Self-Rating</th>
                        <th>HOD-Rating</th>
                        <th>Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Employee</td>
                        <td>
                          <select
                            className="form-control"
                            name="frequency"
                            value={
                              appliedappraisaldetails?.[0]?.frequency || ""
                            }
                            disabled
                          >
                            <option value="Monthly">Monthly</option>
                            <option value="Quarterly">Quarterly</option>
                            <option value="Annually">Annually</option>
                          </select>
                        </td>
                        <td>
                          <StarRating2
                            rating={appliedappraisaldetails?.[0]?.HrRating}
                          />
                        </td>
                        <td>
                          <StarRating2
                            rating={
                              parseFloat(
                                appliedappraisaldetails?.[0]?.selfRating
                              ) || 0
                            }
                          />
                        </td>
                        <td>
                          <StarRating2
                            rating={parseFloat(
                              appliedappraisaldetails?.[0]?.HoDRating
                            )}
                          />
                        </td>
                        <td>
                          <input
                            type="date"
                            className="form-control"
                            value={
                              appliedappraisaldetails?.[0]?.date
                                ? new Date(appliedappraisaldetails?.[0]?.date)
                                  .toISOString()
                                  .split("T")[0]
                                : ""
                            }
                            readOnly
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
        </div>
      </Drawer>

      <Drawer
        title="Feedback Form"
        open={feedbackModalOpen}
        onClose={() => setFeedbackModalOpen(false)}
        placement="right"
        width="75%"
        bodyStyle={{ padding: 20 }}
      >
        <div className="content container-fluid">
          <section className="card border-0">
            <div className="card-header border border-bottom-0 d-flex justify-content-between align-items-center">
              <h3 className="mb-2">Employee Information</h3>
            </div>
            <div className="row">
              <div className="col-md-12 col-sm-12">
                <div className="table-responsive">
                  <form>
                    <table
                      className="table table-bordered mb-0"
                      style={{ minWidth: "1000px" }}
                    >
                      <tbody>
                        <tr>
                          <td>
                            <div className="mb-3">
                              <label className="form-label" htmlFor="name">
                                Name
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="name"
                                value={employeedata?.[0]?.Name}
                                disabled
                              />
                            </div>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="department"
                              >
                                Department
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="department"
                                value={employeedata?.[0]?.department_name}
                                disabled
                              />
                            </div>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="designation"
                              >
                                Designation
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="designation"
                                value={employeedata?.[0]?.designation_name}
                                disabled
                              />
                            </div>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="qualification"
                              >
                                Qualification
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="qualification"
                                value={employeedata?.[0]?.HighestEducation}
                                disabled
                              />
                            </div>
                          </td>

                          <td>
                            <div className="mb-3">
                              <label className="form-label" htmlFor="empID">
                                Emp ID
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="empID"
                                value={employeedata?.[0]?.EmployeeNumber}
                                disabled
                              />
                            </div>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="dateOfJoin"
                              >
                                Date of Join
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="dateOfJoin"
                                value={
                                  employeedata?.[0]?.DateOfJoining?.split(
                                    "T"
                                  )[0]
                                }
                                disabled
                              />
                            </div>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="previousExperience"
                              >
                                Previous years of Exp
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="previousExperience"
                                value={employeedata?.[0]?.total_experience}
                                disabled
                              />
                            </div>
                          </td>

                          <td>
                            <div className="mb-3">
                              <label className="form-label" htmlFor="roName">
                                RO's Name
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="roName"
                                value={employeedata?.[0]?.supervisor_name || ""}
                                disabled
                              />
                            </div>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="roDesignation"
                              >
                                RO Designation
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="roDesignation"
                                value={employeedata?.[0]?.RODesignation || ""}
                                disabled
                              />
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </form>
                </div>
              </div>
            </div>
            <form onSubmit={handleSubmit}>
              <div>
                {filteredRoleIndicators?.length > 0 ? (
                  filteredRoleIndicators.map((role) => (
                    <section className="card border-0 mb-4" key={role.Id}>
                      <div className="card-header border border-bottom-0 text-center">
                        <h3 className="mb-2">
                          {role.Name} - Professional Excellence
                        </h3>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="table-responsive">
                            <table className="table table-bordered mb-0">
                              <thead>
                                <tr>
                                  <th className="width-pixel">#</th>
                                  <th>Key Result Area</th>
                                  <th>Key Performance Indicators</th>
                                  <th>Weightage</th>
                                  <th>Points Scored ( self )</th>
                                  <th>Points Scored (HR)</th>
                                  <th>Points Scored (HOD)</th>
                                </tr>
                              </thead>
                              <tbody>
                                {role.role_groups?.length > 0 ? (
                                  role.role_groups.map((group: any) => (
                                    <tr key={`${role.Id}-${group.serial_no}`}>
                                      <td>{group.serial_no}</td>
                                      <td>
                                        {group?.indicators?.length > 0
                                          ? group.indicators[0]?.kra.name
                                          : "No KRA"}
                                      </td>
                                      <td>
                                        {group?.indicators?.length > 0
                                          ? group.indicators[0]?.indicator.name
                                          : "No Indicator"}
                                      </td>
                                      <td>{group?.weightage}</td>
                                      <td>
                                        <input
                                          type="number"
                                          className="form-control"
                                          placeholder="Enter value"
                                          value={
                                            formData[
                                            `${role.Id}_${group.serial_no}`
                                            ] || ""
                                          }
                                          min="0"
                                          max={group.weightage}
                                          onChange={(e) =>
                                            handleInputChange(
                                              role.Id,
                                              group.serial_no,
                                              e.target.value,
                                              group.weightage
                                            )
                                          }
                                          onInput={(e: any) => {
                                            if (
                                              parseInt(e.target.value, 10) >
                                              group.weightage
                                            ) {
                                              e.target.value = group.weightage;
                                            }
                                          }}
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="number"
                                          className="form-control"
                                          placeholder="Enter value"
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="number"
                                          className="form-control"
                                          placeholder="Enter value"
                                        />
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan={7} className="text-center">
                                      .....No Data Available
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div className="d-flex justify-content-end mt-3">
                          <button
                            type="submit"
                            className="btn btn-primary me-3"
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </section>
                  ))
                ) : (
                  <div className="text-center">No Data Available</div>
                )}

                <div className="card-header border border-bottom-0 text-center">
                  <h3 className="mb-2">Achievements (if any)</h3>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="table-responsive">
                      <table className="table table-bordered table-review mb-0">
                        <thead>
                          <tr>
                            <th className="width-pixel">#</th>
                            <th>By Self</th>
                            {/* <th>By HR</th>
                            <th>By HOD</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {achievement && achievement?.length > 0 ? (
                            achievement.map((ach: any, index: number) => (
                              <tr key={ach.id}>
                                <td>{index + 1}</td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={ach.achievement}
                                    disabled
                                  />
                                </td>
                                {/* <td>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter value"
                                  />
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter value"
                                  />
                                </td> */}
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={4} className="text-center">
                                No achievements recorded.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div className="d-flex justify-content-end mt-3">
                      <button type="submit" className="btn btn-primary me-3">
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <div className="card-header border border-bottom-0 text-center">
              <h3 className="mb-2">Comments on the Role</h3>
              <p className="text-muted">
                Alterations if any required like Addition/Deletion of
                Responsibilities
              </p>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="table-responsive">
                  <table
                    className="table table-bordered mb-0"
                    id="table_alterations"
                  >
                    <thead>
                      <tr>
                        <th className="width-pixel">#</th>
                        <th>By Self</th>
                        {/* <th>By HR</th>
                        <th>By HOD</th> */}
                      </tr>
                    </thead>
                    <tbody id="table_alterations_tbody">
                      {comments && comments?.length > 0 ? (
                        comments.map((com: any, index: any) => (
                          <tr key={com.id}>
                            <td>{index + 1}</td>
                            <td>
                              <input
                                type="text"
                                className="form-control"
                                value={com.self_comment}
                                disabled
                              />
                            </td>
                            {/* <td>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter RO comment"
                                value={com.ro_comment}
                                // onChange={(e) =>
                                //   handleCommentChange(index, "ro_comment", e.target.value)
                                // }
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter HOD comment"
                                value={com.hod_comment}
                                // onChange={(e) =>
                                //   handleCommentChange(index, "hod_comment", e.target.value)
                                // }
                              />
                            </td> */}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={4} className="text-center">
                            No comments available.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="d-flex justify-content-end mt-3">
                  {/* <button type="submit" className="btn btn-primary me-3">
                    Save
                  </button> */}
                </div>
              </div>
            </div>
            <div className="card-header border border-bottom-0 text-center">
              <h3 className="mb-2">Personal Goals</h3>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="table-responsive">
                  <table className="table table-bordered mb-0">
                    <thead>
                      <tr>
                        <th className="width-pixel">#</th>
                        <th>Goal Achieved during last year</th>
                        <th>Goal set for current year</th>
                      </tr>
                    </thead>
                    <tbody>
                      {personalgoal && personalgoal.length > 0 ? (
                        personalgoal.map((goal: any, index: number) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>
                              <input
                                type="text"
                                className="form-control"
                                value={goal.personalgoallast?.join(", ") || ""}
                                disabled
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                className="form-control"
                                value={
                                  goal.personalgoalcurrent?.join(", ") || ""
                                }
                                disabled
                              />
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={3} className="text-center">
                            No personal goals available.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="card-header border border-bottom-0 text-center">
              <h3 className="mb-2">
                Professional Goals Achieved for last year
              </h3>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="table-responsive">
                  <table className="table table-bordered mb-0" id="table_goals">
                    <thead>
                      <tr>
                        <th className="width-pixel">#</th>
                        <th>By Self</th>
                      </tr>
                    </thead>
                    <tbody id="table_goals_tbody">
                      {professionalgoallastyear &&
                        professionalgoallastyear.length > 0 ? (
                        professionalgoallastyear.map(
                          (goal: any, index: number) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={goal.goalName}
                                  disabled
                                />
                              </td>
                            </tr>
                          )
                        )
                      ) : (
                        <tr>
                          <td colSpan={2} className="text-center">
                            No professional goals from last year.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="card-header border border-bottom-0 text-center">
              <h3 className="mb-2">
                Professional Goals for the forthcoming year
              </h3>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="table-responsive">
                  <table
                    className="table table-bordered mb-0"
                    id="table_forthcoming"
                  >
                    <thead>
                      <tr>
                        <th className="width-pixel">#</th>
                        <th>By Self</th>
                      </tr>
                    </thead>
                    <tbody id="table_forthcoming_tbody">
                      {professionalgoalcurrentyear &&
                        professionalgoalcurrentyear.length > 0 ? (
                        professionalgoalcurrentyear.map(
                          (goal: any, index: number) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={goal.goalName}
                                  disabled
                                />
                              </td>
                            </tr>
                          )
                        )
                      ) : (
                        <tr>
                          <td colSpan={2} className="text-center">
                            No professional goals set for current year.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="row mb-4">
              <div className="col-md-12">
                <div className="table-responsive">
                  <table className="table table-bordered mb-0">
                    <thead>
                      <tr>
                        <th>Role</th>
                        <th>Frequency</th>
                        <th>HR-Rating</th>
                        <th>Self-Rating</th>
                        <th>HOD-Rating</th>
                        <th>Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Employee</td>
                        <td>
                          <select
                            className="form-control"
                            name="frequency"
                            value={
                              appliedappraisaldetails?.[0]?.frequency || ""
                            }
                            disabled
                          >
                            <option value="Monthly">Monthly</option>
                            <option value="Quarterly">Quarterly</option>
                            <option value="Annually">Annually</option>
                          </select>
                        </td>
                        <td>
                          <StarRating
                            rating={ratings.hrRating}
                            onRate={(value) =>
                              setRatings((prev) => ({
                                ...prev,
                                hrRating: value,
                              }))
                            }
                          />
                        </td>
                        <td>
                          <StarRating2
                            rating={
                              parseFloat(
                                appliedappraisaldetails?.[0]?.selfRating
                              ) || 0
                            }
                          />
                        </td>
                        <td>
                          <StarRating
                            rating={ratings.hodRating}
                            onRate={(value) =>
                              setRatings((prev) => ({
                                ...prev,
                                hodRating: value,
                              }))
                            }
                          />
                        </td>
                        <td>
                          <input
                            type="date"
                            className="form-control"
                            value={
                              appliedappraisaldetails?.[0]?.date
                                ? new Date(appliedappraisaldetails?.[0]?.date)
                                  .toISOString()
                                  .split("T")[0]
                                : ""
                            }
                            readOnly
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="d-flex justify-content-end mt-3">
                <button
                  type="submit"
                  className="btn btn-primary me-3"
                  onClick={handleemployeeSubmit}
                >
                  Submit Rating
                </button>
              </div>
            </div>
          </section>
        </div>
      </Drawer>
    </>
  );
};

export default PerformanceReview;
